import { defineMessages } from 'react-intl';
export const messages = defineMessages({
  placeholder: {
    id: 'components.SearchBar.placeholder',
    defaultMessage: '¿Qué desea buscar?'
  }
});